import { Sortable } from "@shopify/draggable";
import RailsAjax from "../shared/rails-ajax";

export default function SortableList() {
  const containerSelector = ".mdc-data-table__content";
  const handleClass = "sortable-list-item-handle";
  const containers = Array.from(document.querySelectorAll(containerSelector));

  if (containers.length === 0) {
    return false;
  }

  const sortable = new Sortable(containers, {
    draggable: ".sortable-list-is-draggable",
    mirror: {
      appendTo: containerSelector,
      constrainDimensions: true
    }
  });

  // prevent dragging except via the handle
  sortable.on("drag:start", (event) => {
    const currentTarget = event.originalEvent.target;

    if (!currentTarget.classList.contains(handleClass)) {
      event.cancel();
    }
  });

  sortable.on("sortable:stop", () => {
    let resourceIds = [];
    let resourceKlasses = [];
    document.querySelectorAll(".sortable-list-is-draggable").forEach((node) => {
      if (
        node.classList.contains("draggable--original") ||
        node.classList.contains("draggable-mirror")
      ) {
        return;
      }
      resourceIds.push(node.dataset.id);
      resourceKlasses.push(node.dataset.klass);
    });

    const actionUrl = containers[0].dataset.action;
    RailsAjax.post(actionUrl, { klasses: resourceKlasses, ids: resourceIds });
  });

  return sortable;
}

//  Copyright © 2018 by Northwestern University. All Rights Reserved.
